import React, { useState } from 'react'
import {
  ChevronDown,
  Globe,
  Smartphone,
  Code,
  ArrowRight,
  Check,
  ShoppingCart,
  Brain,
  AlertCircle,
  CheckCircle,
  Rocket,
} from 'lucide-react'
// import { FaEnvelope, FaWhatsapp } from 'react-icons/fa'
import styles from './Accueil.module.scss'
import rea_1 from '../assets/images/rea_1.png'
import rea_2 from '../assets/images/rea_2.png'
import rea_3 from '../assets/images/rea_3.png'
import rea_4 from '../assets/images/rea_4.png'
import rea_5 from '../assets/images/rea_5.png'
import rea_6 from '../assets/images/rea_6.png'
import fav_1 from '../assets/images/fav_1.png'
import fav_2 from '../assets/images/fav_2.png'
import fav_3 from '../assets/images/fav_3.png'
import fav_4 from '../assets/images/fav_4.png'
import fav_5 from '../assets/images/fav_5.png'
import fav_6 from '../assets/images/fav_6.png'
import logo from '../assets/images/logo_laguinda.png'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'

export default function Accueil() {
  const [showModal, setShowModal] = useState(false)
  const [showContactModal, setShowContactModal] = useState(false)

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    projectType: '',
    message: '',
  })

  const [contactData, setContactData] = useState({
    name: '',
    email: '',
    message: '',
  })

  const [quoteMessage, setQuoteMessage] = useState({ type: '', text: '' })
  const [contactMessage, setContactMessage] = useState({ type: '', text: '' })
  const [loadingQuote, setLoadingQuote] = useState(false)
  const [loadingContact, setLoadingContact] = useState(false)

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleContactChange = (e) => {
    const { name, value } = e.target
    setContactData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoadingQuote(true)
    setQuoteMessage({ type: '', text: '' })

    try {
      if (
        !formData.name ||
        !formData.email ||
        !formData.projectType ||
        !formData.message
      ) {
        setQuoteMessage({
          type: 'error',
          text: 'Veuillez remplir tous les champs obligatoires.',
        })
        setLoadingQuote(false)
        return
      }

      const myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/json')

      const raw = JSON.stringify({
        smtp_sender_name: 'LAGUINDA',
        to: '',
        subject: 'Demande de devis',
        message: `
          <div>
            <p><span style={fontWeight: "bold"}>Type de projet :</span> ${formData.projectType}</p>
            <p><span style={fontWeight: "bold"}>Email :</span> ${formData.email}</p>
            <p><span style={fontWeight: "bold"}>Téléphone :</span> ${formData.phone}</p>
            <p><span style={fontWeight: "bold"}>Entreprise :</span> ${formData.company}</p>
            <p><span style={fontWeight: "bold"}>Nom :</span> ${formData.name}</p>
            <p><span style={fontWeight: "bold"}>Message :</span> ${formData.message}</p>
          </div>
        `,
        motif: 'wantDevis',
      })

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
      }

      const response = await fetch(
        'https://script-utils-1.onrender.com/send-mail',
        requestOptions,
      )

      if (response.ok) {
        setQuoteMessage({
          type: 'success',
          text: 'Merci ! Votre demande a été envoyée. Notre équipe vous contactera bientôt.',
        })

        setTimeout(() => {
          setFormData({
            name: '',
            email: '',
            phone: '',
            company: '',
            projectType: '',
            message: '',
          })
          setShowModal(false)
          setQuoteMessage({ type: '', text: '' })
        }, 2000)
      } else {
        setQuoteMessage({
          type: 'error',
          text: "Une erreur s'est produite. Veuillez réessayer.",
        })
      }
    } catch (error) {
      setQuoteMessage({
        type: 'error',
        text: "Une erreur s'est produite. Veuillez réessayer.",
      })
    } finally {
      setLoadingQuote(false)
    }
  }

  const handleContactSubmit = async (e) => {
    e.preventDefault()
    setLoadingContact(true)
    setContactMessage({ type: '', text: '' })

    try {
      if (!contactData.name || !contactData.email || !contactData.message) {
        setContactMessage({
          type: 'error',
          text: 'Veuillez remplir tous les champs obligatoires.',
        })
        setLoadingContact(false)
        return
      }

      await new Promise((resolve) => setTimeout(resolve, 1200))

      const myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/json')

      const raw = JSON.stringify({
        smtp_sender_name: 'LAGUINDA',
        to: '',
        subject: 'Message via formulaire de contact',
        message: `
          <div>
            <p><span style={fontWeight: "bold"}>Email :</span> ${contactData.email}</p>
            <p><span style={fontWeight: "bold"}>Nom :</span> ${contactData.name}</p>
            <p><span style={fontWeight: "bold"}>Message :</span> ${contactData.message}</p>
          </div>
        `,
        motif: 'contactUs',
      })

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
      }

      const response = await fetch(
        'https://script-utils-1.onrender.com/send-mail',
        requestOptions,
      )

      if (response.ok) {
        setContactMessage({
          type: 'success',
          text: 'Merci pour votre message ! Nous vous répondrons rapidement.',
        })

        setTimeout(() => {
          setContactData({ name: '', email: '', message: '' })
          setShowContactModal(false)
          setContactMessage({ type: '', text: '' })
        }, 2000)
      } else {
        setContactMessage({
          type: 'error',
          text: "Une erreur s'est produite. Veuillez réessayer.",
        })
      }
    } catch (error) {
      setContactMessage({
        type: 'error',
        text: "Une erreur s'est produite. Veuillez réessayer.",
      })
    } finally {
      setLoadingContact(false)
    }
  }

  const services = [
    {
      icon: Globe,
      title: 'Sites Web & Web Apps',
      description:
        'Création de plateformes web performantes, responsive et optimisées SEO.',
    },
    {
      icon: Smartphone,
      title: 'Applications Mobiles',
      description:
        'Développement iOS & Android fluide et intuitif pour vos utilisateurs.',
    },
    {
      icon: Code,
      title: 'Développement sur mesure',
      description:
        'Solutions personnalisées adaptées à vos besoins métier et à votre budget.',
    },
    {
      icon: Brain,
      title: 'Intelligence Artificielle',
      description:
        'Automatisation, chatbots et intégrations IA pour booster votre activité.',
    },
    {
      icon: ShoppingCart,
      title: 'E-commerce & Paiement',
      description:
        'Conception de boutiques modernes avec gestion complète et sécurité optimale.',
    },
    {
      icon: Rocket,
      title: 'Stratégie Digitale',
      description:
        'Accompagnement 360° pour propulser votre présence en ligne.',
    },
  ]

  const realisations = [
    {
      title: 'OGC',
      description:
        'Solution de gestion de commerce complet, permettant le suivi des ventes, la gestion des stocks et la consultation d’analyses en temps réel.',
      imagUrl: rea_1,
      faviconUrl: fav_1,
    },
    {
      title: 'influenspace',
      description:
        'Application web de mise en relation entre porteurs de projets, marques et influenceurs / créateurs de contenu.',
      imagUrl: rea_6,
      faviconUrl: fav_6,
    },
    {
      title: 'Full Analytics',
      description:
        'Dashboard interactif avec graphiques dynamiques et analyses détaillées des performances.',
      imagUrl: rea_3,
      faviconUrl: fav_3,
    },
    {
      title: 'ENGUI',
      description:
        'Plateforme de consultation des examens nationaux en Guinée en temps réel, fiable et rapide.',
      imagUrl: rea_5,
      faviconUrl: fav_5,
    },
    {
      title: 'Booki',
      description:
        'Un site web moderne et ergonomique pour faciliter la réservation de logements et séjours en quelques clics.',
      imagUrl: rea_4,
      faviconUrl: fav_4,
    },
    {
      title: 'Ohmyfood',
      description:
        'Une plateforme innovante permettant de commander et prévisualiser des menus en ligne avant même d’arriver au restaurant.',
      imagUrl: rea_2,
      faviconUrl: fav_2,
    },
  ]

  const benefits = [
    'Interface intuitive et accessible',
    'Intégrations avec les outils majeurs',
    'Sécurité de niveau moderne',
    'Mises à jour régulières',
    'Support Premium',
  ]

  return (
    <div className={styles.container}>
      <Helmet>
        <title>LAGUINDAWS — Construisons ensemble votre empire numérique</title>
        <meta name='robots' content='index, follow' />
      </Helmet>

      {/* === HERO === */}
      <section className={styles.hero}>
        <div className={styles.heroGradient}></div>

        <div className={styles.heroContent}>
          <div className={styles.heroBadge}>
            🚀 Agence Web Créative & Digitale
          </div>

          <h1 className={styles.heroTitle}>
            Construisons ensemble
            <br />
            <span className={styles.gradient}>Votre Empire Numérique</span>
          </h1>

          <p className={styles.heroDesc}>
            Nous concevons des expériences digitales sur mesure : sites web,
            applications, et solutions intelligentes pour faire décoller votre
            business.
          </p>

          <div className={styles.heroCTA}>
            <button
              onClick={() =>
                document
                  .getElementById('services')
                  .scrollIntoView({ behavior: 'smooth' })
              }
              className={styles.ctaPrimary}
            >
              Nos Services <ArrowRight size={20} />
            </button>

            <button
              onClick={() => setShowModal(true)}
              className={styles.ctaSecondary}
            >
              Obtenir un Devis
            </button>
          </div>

          <div className={styles.heroChevron}>
            <ChevronDown className={styles.chevron} size={28} />
          </div>
        </div>
      </section>

      {/* === OGC SECTION === */}
      <section className={styles.ogcSection} id='ogc'>
        <div className={styles.ogcWrapper}>
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>
              Notre{' '}
              <span className={styles.gradient}>Dernière Réalisation</span>
            </h2>
            <p className={styles.sectionDesc}>
              Découvrez OGC224, notre toute nouvelle solution conçue pour{' '}
              <span style={{ color: 'white' }}>
                optimiser la gestion de votre commerce.
              </span>{' '}
              <br />
              Innovante, intuitive et performante, elle vous accompagne au
              quotidien pour{' '}
              <span style={{ color: 'white' }}>
                gagner du temps et faire croître votre activité.
              </span>
            </p>
          </div>
          <div className={styles.ogcBox}>
            <div className={styles.ogcLeft}>
              <div className={styles.ogcIcon}>
                <ShoppingCart size={40} />
              </div>

              <h2 className={styles.ogcTitle}>
                <span className={styles.gradient}>OGC224</span>
              </h2>

              <p className={styles.ogcDesc}>
                Outil de Gestion de Commerce - Gérez vos produits, suivez vos
                achats et consultez vos statistiques en temps réel.
              </p>

              <div className={styles.ogcFeatures}>
                {[
                  'Gestion complète des produits',
                  'Suivi des achats et commandes',
                  'Analytics détaillées CA/Ventes',
                  'Tableau de bord personnalisable',
                ].map((f, i) => (
                  <div key={i} className={styles.feature}>
                    <Check size={16} className={styles.checkIcon} />
                    <span>{f}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className={styles.ogcBottom}>
              <div className={styles.ogcPrice}>
                <div className={styles.priceLabel}>À partir de</div>
                <div className={styles.priceValue}>
                  50 000 <span>GNF</span>
                </div>
                <div className={styles.priceLabel}>par mois</div>
              </div>

              <div className={styles.ogcButton}>
                <a
                  href='https://ogc.laguindaws.com'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Essayer gratuitement <ArrowRight size={18} />
                </a>
                <p
                  style={{
                    fontWeight: '300',
                    fontSize: '14px',
                    margin: '10px 0px',
                    textAlign: 'center',
                  }}
                >
                  ( essayer gratuitement dès maintenant pendant 7 jours )
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* === SERVICES === */}
      <section className={styles.servicesSection} id='services'>
        <div className={styles.servicesWrapper}>
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>
              Nos <span className={styles.gradient}>Expertises</span>
            </h2>
            <p className={styles.sectionDesc}>
              Nous offrons des solutions digitales innovantes et performantes
              pour propulser votre activité. <br />
              De la conception à la mise en ligne, chaque projet est pensé pour
              créer de la valeur et un impact durable.
            </p>
          </div>

          <div className={styles.scrollContainer}>
            {services.map((service, index) => {
              const Icon = service.icon
              return (
                <div key={index} className={styles.serviceCard}>
                  <div className={styles.serviceIcon}>
                    <Icon size={24} />
                  </div>
                  <h3 className={styles.serviceTitle}>{service.title}</h3>
                  <p className={styles.serviceDesc}>{service.description}</p>
                </div>
              )
            })}
          </div>
        </div>
      </section>

      {/* === REALISATIONS === */}
      <section className={styles.realisationsSection} id='realisations'>
        <div className={styles.realisationsWrapper}>
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>
              Nos <span className={styles.gradient}>Réalisations</span>
            </h2>
            <p className={styles.sectionDesc}>
              Découvrez quelques-uns de nos projets récents, conçus pour
              répondre aux besoins de nos clients avec innovation, performance
              et élégance.
            </p>
          </div>

          <div className={styles.realisationsGrid}>
            {realisations.map((realisation, index) => (
              <div key={index} className={styles.realisationCard}>
                <img
                  src={realisation.imagUrl}
                  alt=''
                  title={realisation.title}
                ></img>

                <div className={styles.realisationContent}>
                  <h3 className={styles.realisationTitle}>
                    <img
                      className={styles.faviconRea}
                      src={realisation.faviconUrl}
                      alt=''
                      title={realisation.title}
                    />{' '}
                    {realisation.title}
                  </h3>
                  <p className={styles.realisationDesc}>
                    {realisation.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* === CTA === */}
      <section className={styles.ctaSection}>
        <div className={styles.ctaWrapper}>
          <div className={styles.ctaBox}>
            <h2 className={styles.ctaTitle}>Vous avez un projet en tête ?</h2>
            <p className={styles.ctaDesc}>
              Donnez vie à vos idées grâce à notre expertise. Nous concevons des
              solutions digitales uniques, performantes et centrées sur
              l’expérience utilisateur.
            </p>

            <h3 className={styles.benefitsTitle}>
              Ce que vous obtenez chez LAGUINDA
              <span style={{ color: 'white' }}>WS</span>
            </h3>
            <div className={styles.benefitsGrid}>
              {benefits.map((benefit, i) => (
                <div key={i} className={styles.benefitItem}>
                  <Check className={styles.checkIcon} size={20} />
                  <span>{benefit}</span>
                </div>
              ))}
            </div>

            <div className={styles.ctaButtons}>
              <button
                onClick={() => setShowModal(true)}
                className={styles.ctaPrimary}
              >
                Demander un devis
              </button>
              <button
                onClick={() =>
                  document
                    .getElementById('services')
                    .scrollIntoView({ behavior: 'smooth' })
                }
                className={styles.ctaSecondary}
              >
                Voir nos services
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* === FOOTER === */}
      <footer className={styles.footer}>
        <div className={styles.footerWrapper}>
          <div className={styles.footerGrid}>
            <div className={styles.footerSection}>
              <img style={{ width: '100px' }} src={logo} alt='logo-laguinda' />
            </div>

            <div className={styles.footerSection}>
              <h4 className={styles.footerTitle}>Légal</h4>
              <ul className={styles.footerList}>
                <li>
                  <Link to='/mentions-legales'>Mentions Légales</Link>
                </li>
                <li>
                  <Link to='/conditions-generales'>CGU de Confidentialité</Link>
                </li>
              </ul>
            </div>

            <div className={styles.footerSection}>
              <h4 className={styles.footerTitle}>Liens rapide</h4>
              <ul className={styles.footerList}>
                <li>
                  <Link
                    href='#'
                    onClick={(e) => {
                      e.preventDefault()
                      setShowModal(true)
                    }}
                  >
                    Demander un devis
                  </Link>
                </li>
                <li>
                  <Link
                    href='#'
                    onClick={(e) => {
                      e.preventDefault()
                      setShowContactModal(true)
                    }}
                  >
                    Formulaire de contact
                  </Link>
                </li>
              </ul>
            </div>

            {/* <div className={styles.footerSection}>
              <h4 className={styles.footerTitle}>Support</h4>
              <ul className={styles.footerList}>
                <li>
                  <a
                    href='https://wa.me/224621994206'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <FaWhatsapp /> Nous contacter sur WhatsApp
                  </a>
                </li>
                <li>
                  <a
                    href='mailto:contact@laguindaws.com'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <FaEnvelope /> contact@laguindaws.com
                  </a>
                </li>
              </ul>
            </div> */}
          </div>

          <div className={styles.footerBottom}>
            <p>
              © {new Date().getFullYear()} LAGUINDAWS. Tous droits réservés. |
              Construisons ensemble votre Empire Numérique
            </p>
          </div>
        </div>
      </footer>

      {/* === DEVIS MODAL === */}
      {showModal && (
        <div className={styles.modal} onClick={() => setShowModal(false)}>
          <div
            className={styles.modalContent}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={styles.modalHeader}>
              <h2>
                Demander un <span className={styles.gradient}>Devis</span>
              </h2>
              <button
                className={styles.modalClose}
                onClick={() => setShowModal(false)}
              >
                ✕
              </button>
            </div>

            <form onSubmit={handleSubmit} className={styles.form}>
              <div className={styles.formRow}>
                <div className={styles.formGroup}>
                  <label>Nom complet *</label>
                  <input
                    type='text'
                    name='name'
                    value={formData.name}
                    onChange={handleInputChange}
                    disabled={loadingQuote}
                    placeholder='Hawa Camara'
                  />
                </div>
                <div className={styles.formGroup}>
                  <label>Email *</label>
                  <input
                    type='email'
                    name='email'
                    value={formData.email}
                    onChange={handleInputChange}
                    disabled={loadingQuote}
                    placeholder='votremail@gmail.com'
                  />
                </div>
              </div>

              <div className={styles.formRow}>
                <div className={styles.formGroup}>
                  <label>Téléphone</label>
                  <input
                    type='tel'
                    name='phone'
                    value={formData.phone}
                    onChange={handleInputChange}
                    disabled={loadingQuote}
                    placeholder='+224 621 99 42 06'
                  />
                </div>
                <div className={styles.formGroup}>
                  <label>Entreprise</label>
                  <input
                    type='text'
                    name='company'
                    value={formData.company}
                    onChange={handleInputChange}
                    disabled={loadingQuote}
                    placeholder='Votre Entreprise'
                  />
                </div>
              </div>

              <div className={styles.formGroup}>
                <label>Type de projet *</label>
                <select
                  name='projectType'
                  value={formData.projectType}
                  onChange={handleInputChange}
                  disabled={loadingQuote}
                >
                  <option value=''>Sélectionnez un type...</option>
                  <option value='siteWeb'>Site Web (Landing Page)</option>
                  <option value='appliWeb'>Application Web</option>
                  <option value='appliMobile'>Application Mobile</option>
                  <option value='ecommerce'>E-commerce</option>
                  <option value='api'>API & Intégration</option>
                  <option value='surMesure'>Développement Custom</option>
                  <option value='ia'>Intégration IA</option>
                </select>
              </div>

              <div className={styles.formGroup}>
                <label>Décrivez votre projet *</label>
                <textarea
                  name='message'
                  value={formData.message}
                  onChange={handleInputChange}
                  disabled={loadingQuote}
                  rows='5'
                  placeholder='Décrivez votre projet...'
                ></textarea>
              </div>

              {quoteMessage.text && (
                <div
                  className={`${styles.message} ${
                    quoteMessage.type === 'success'
                      ? styles.messageSuccess
                      : styles.messageError
                  }`}
                >
                  {quoteMessage.type === 'success' ? (
                    <CheckCircle size={18} />
                  ) : (
                    <AlertCircle size={18} />
                  )}
                  <span>{quoteMessage.text}</span>
                </div>
              )}

              <div className={styles.formActions}>
                <button
                  type='submit'
                  disabled={loadingQuote}
                  className={styles.ctaPrimary}
                >
                  {loadingQuote ? 'Envoi...' : 'Envoyer la Demande'}
                </button>
                <button
                  type='button'
                  onClick={() => setShowModal(false)}
                  disabled={loadingQuote}
                  className={styles.ctaSecondary}
                >
                  Annuler
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* === CONTACT MODAL === */}
      {showContactModal && (
        <div
          className={styles.modal}
          onClick={() => setShowContactModal(false)}
        >
          <div
            className={styles.modalContent}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={styles.modalHeader}>
              <h2>
                Nous <span className={styles.gradient}>Contacter</span>
              </h2>
              <button
                className={styles.modalClose}
                onClick={() => setShowContactModal(false)}
              >
                ✕
              </button>
            </div>

            <form onSubmit={handleContactSubmit} className={styles.form}>
              <div className={styles.formGroup}>
                <label>Nom complet *</label>
                <input
                  type='text'
                  name='name'
                  value={contactData.name}
                  onChange={handleContactChange}
                  disabled={loadingContact}
                  placeholder='Hawa Camara'
                />
              </div>

              <div className={styles.formGroup}>
                <label>Email *</label>
                <input
                  type='email'
                  name='email'
                  value={contactData.email}
                  onChange={handleContactChange}
                  disabled={loadingContact}
                  placeholder='votremail@gmail.com'
                />
              </div>

              <div className={styles.formGroup}>
                <label>Message *</label>
                <textarea
                  name='message'
                  value={contactData.message}
                  onChange={handleContactChange}
                  disabled={loadingContact}
                  rows='5'
                  placeholder='Votre message...'
                ></textarea>
              </div>

              {contactMessage.text && (
                <div
                  className={`${styles.message} ${
                    contactMessage.type === 'success'
                      ? styles.messageSuccess
                      : styles.messageError
                  }`}
                >
                  {contactMessage.type === 'success' ? (
                    <CheckCircle size={18} />
                  ) : (
                    <AlertCircle size={18} />
                  )}
                  <span>{contactMessage.text}</span>
                </div>
              )}

              <div className={styles.formActions}>
                <button
                  type='submit'
                  disabled={loadingContact}
                  className={styles.ctaPrimary}
                >
                  {loadingContact ? 'Envoi...' : 'Envoyer'}
                </button>
                <button
                  type='button'
                  onClick={() => setShowContactModal(false)}
                  disabled={loadingContact}
                  className={styles.ctaSecondary}
                >
                  Annuler
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}
